import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getPrettyDate } from 'utils/util/util';
import { AvatarBasicPerson } from 'views/Widgets/People/UnlinkedAvatar';

const FeedbackCompletedOverlay: FC<{
  ap: AvatarBasicPerson;
}> = ({ ap }) => {
  const { locale } = useIntl();
  // @ts-expect-error
  if (ap?.completed_date)
    return (
      <div>
        <FormattedMessage
          id="app.views.administration.content_administration.feedback_recognition.requested.table.column.completed_at.value.completed"
          defaultMessage="Feedback given on {date}"
          values={{
            // @ts-expect-error
            date: getPrettyDate({ dateString: ap.completed_date, locale }),
          }}
        />
      </div>
    );
  return null;
};

export default React.memo(FeedbackCompletedOverlay);
